<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import { useModeStore } from '../store/mode.js';
import { useThemeStore } from '../store/theme.js';
// import { useUserStore } from '@/store/user';

const modeStore = useModeStore();
// const userStore = useUserStore();
const themeStore = useThemeStore();
const route = useRoute()
// const articleId = route.params.id
const article = ref(null)
const relatedArticles = ref([])

const backgroundClass = computed(() => {
  const mode = modeStore.selectedMode;
  const theme = themeStore.selectedTheme;
  return `${mode}-mode-${theme}-bg`;
});

const fetchArticle = async (id) => {
  try {
    const res = await axios.get(`/api/v1/help/articles/${id}`)
    article.value = res.data.data || res.data
    relatedArticles.value = article.value.topic?.articles || []
    console.log('Fetched article:', article.value)
    console.log('Related articles:', article.value.topic?.articles)
  } catch (error) {
    console.error('Error loading article:', error)
  }
}

watch(() => route.params.id, async (newId) => {
  await fetchArticle(newId)
}, { immediate: true })

</script>

<template>
    <div :class="backgroundClass" class="min-h-screen mx-auto p-6">
        <div class="flex flex-col lg:flex-row max-w-6xl mx-auto p-6">
            <!-- Sidebar -->
            <aside class="lg:w-1/4 mb-6 lg:mb-0 lg:pr-6 border-r border-gray-200">
            <h3 class="font-bold text-lg mb-3">Artikel Berkaitan</h3>
            <ul class="space-y-2">
                <li v-for="a in relatedArticles" :key="a.id">
                <router-link :to="`/help/article/${a.id}`" class="text-blue-600 hover:underline" :class="{ 'font-semibold': a.id == article.id }">
                    {{ a.article_name }}
                </router-link>
                </li>
            </ul>
            </aside>

            <!-- Main Content -->
            <main class="lg:w-3/4">
            <router-link to="/help" class="text-blue-600 hover:underline text-sm inline-block mb-4">← Kembali ke Topik</router-link>
            <h1 class="text-2xl font-bold mb-4">{{ article?.article_name }}</h1>
            <div class="prose" v-html="article?.description" />
            </main>
        </div>
    </div>
</template>
